import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import IconButton from "@mui/material/IconButton";
import { FC, Fragment, memo, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Constants from "../../../constant";
import { getTaskAPI } from "../../../redux/sagas/task.saga";
import Config from "@hero/shared/models/config";
import { IStatus } from "@hero/shared/models/status";
import { ITask } from "@hero/shared/models/task";
import { IUserInfo } from "@hero/shared/models/userInfo";
import { hexToRgbA } from "../../../utils";
import Column from "../Column";
import { SelectFilterItem } from "../projects-filter/select-filter";
import TaskPreview, { getChildTasks } from "../task-preview";
import NewEditTaskModal from "../task-preview/edit-task-modal/new_edit_task";
import TestCycleModalWidget from "../task-preview/test-cycle-modal";
import "./style.scss";

export const checkContainsArray = (arr1: string[], arr2: string[]) => {
    if (!arr1.length || !arr2.length) return false;
    for (let item of arr1) {
        if (arr2.includes(item)) {
            return true;
        }
    }
    return false;
};
export const checkRelatedToTask = (task: ITask, users: string[], allTasks: ITask[]) => {
    let check0 = checkContainsArray(
        [task.assigneeId, task.reporterId, ...task.testerIds, task.leadDevId, ...task.inform],
        users
    );
    //assignee, reporter, inform, tester
    let childTasks = getChildTasks(task, allTasks);
    let check = false;
    if (childTasks.length > 0) {
        for (let t of childTasks) {
            if (!check) {
                check = checkContainsArray(users, [t.assigneeId, t.reporterId, ...t.inform, ...t.testerIds]);
            }
        }
    }
    return check || check0;
};
const DashboardSprintColumnsV2: FC<{
    currentProjectIds: string[];
    currentUserIds: string[];
    showAllTasks: boolean;
    forceCurrentCampaignIds: string[] | null;
    selectedFilters: SelectFilterItem[];
    setMembersInGroup: string[];
    isShowCheckBox? : boolean;
    handleGetIds? : (listId : string[]) => void
}> = ({ currentProjectIds, currentUserIds, showAllTasks, forceCurrentCampaignIds, selectedFilters, setMembersInGroup,isShowCheckBox,handleGetIds = () => {} }) => {
    const userInfo: IUserInfo = useSelector((state: any) => state.authState.user);
    const isAdmin = userInfo.role == 1;
    const status: IStatus[] = useSelector((state: any) => state.statusState.status ?? []);
    const allTasks: ITask[] = useSelector((state: any) => state.taskState.tasks ?? []);

    // const taskShown: ITask | undefined = useSelector((state: any) => state.taskState.taskShown);
    const [taskShown, setTaskShown] = useState<ITask | null>(null);
    const mapTasks: Map<string, ITask[]> = new Map();
    for (let task of allTasks) {
        if (!mapTasks.has(task.statusId)) {
            mapTasks.set(task.statusId, []);
        }
        mapTasks.get(task.statusId)?.push(task);
    }
    const campaignTasks = useSelector((state: any) => state.taskState.campaignTasks);
    const ref = useRef<HTMLDivElement | null>(null);
    let today = new Date();
    
    const filterTasks = (tasks: ITask[], statusId: string) => {
        if (forceCurrentCampaignIds) {
            let listTasks: ITask[] = [];
            forceCurrentCampaignIds.forEach((id: string) => {
                let campaignTask = campaignTasks[id] ?? [];
                campaignTask.forEach((element: ITask) => {
                    if (listTasks.find((item) => item._id === element._id)) return;
                    if (element.statusId === statusId) listTasks.push(element);
                });
            });
            return listTasks;
        }
        return tasks.filter((task) => {
            if (task.type === "Sub Task" && !showAllTasks) return;
            if (task.statusView !== Config.STATUS_PUBLIC) return;
            
            if (selectedFilters.length > 0) {
                let listUsers = !currentUserIds.length ? [userInfo._id] : currentUserIds;
                let istaskChange : boolean = false;
                task.histories.forEach((item) => {
                    if((item.to == "616eabdaccb9dac54a200237" || item.to == "616eabf9ccb9dac54a200240") && (today.getDate() == item.time.getDate() && today.getMonth() == item.time.getMonth() && today.getFullYear() == item.time.getFullYear())){
                        istaskChange = true;
                    }
                });
                const isCheckReporter = selectedFilters.some(u => u.isReporter());
                const isCheckTester = selectedFilters.some(u => u.isTester());
                const isCheckBug = selectedFilters.some(u => u.isBug());
                const isCheckInform = selectedFilters.some(u => u.isInform());
                const isCheckLeader = selectedFilters.some(u => u.isLeader());
                const isCheckTestToday = selectedFilters.some(u => u.isTestToday());
                const isCheckAssignee = selectedFilters.some(u => u.isAssignee());
                const isCheckTag = selectedFilters.some(u => u.isTag());
                return (
                    ((isCheckReporter &&
                        (!listUsers.length || checkContainsArray([task.reporterId], listUsers))) ||
                        (isCheckTester && (!listUsers.length || checkContainsArray(task.testerIds, listUsers))) ||
                        (isCheckBug && task.type === "Bug" && (!listUsers.length || checkContainsArray(task.testerIds, listUsers))) ||
                        (isCheckInform && (!listUsers.length || checkContainsArray(task.inform, listUsers))) ||
                        (isCheckLeader && (!listUsers.length || checkContainsArray([task.leadDevId], listUsers))) ||
                        // (selectedFilter === "Follower" &&
                        //     (!listUsers.length || checkContainsArray(task.followerIds, listUsers))) ||
                         (isCheckTestToday && (task.status?._id == "616eabdaccb9dac54a200237" || task.status?._id == "616eabf9ccb9dac54a200240") && istaskChange ) ||
                        (isCheckAssignee &&
                            (!listUsers.length ||
                                checkContainsArray(
                                    [task.assigneeId, ...getChildTasks(task, allTasks).map((t) => t.assigneeId)],
                                    listUsers
                                )))) &&
                    (!currentProjectIds.length || checkContainsArray([task.projectId], currentProjectIds))
                    || isCheckTag && task.tags.some(u => selectedFilters.some(a => a.id === u))
                );
            }
            const checkProject = !currentProjectIds.length || currentProjectIds.includes(task.projectId);

            /*
            - Admin: all tasks
              lead: all tasks related to members in group and themself
              member: all task related to themself
            - Selected: all tasks related to themself
            */
            const checkUser = !currentUserIds.length // don't select users
                ? isAdmin || task.createdUserId == userInfo._id //isAdmin: show all tasks
                    ? true
                    : setMembersInGroup.length // is leader: show tasks which related to members in group and themself
                    ? checkRelatedToTask(task, setMembersInGroup, allTasks)
                    : //is member: show tasks which related to themself
                      checkRelatedToTask(task, [userInfo._id], allTasks)
                : //selected users
                  checkRelatedToTask(task, currentUserIds, allTasks) && // kiem tra xem task nay co lien quan den currentUserIds khong (task cha va task con)
                  (isAdmin
                      ? true
                      : checkRelatedToTask(task, setMembersInGroup, allTasks) || // else: show tasks which related to members in group and selected user
                        task.createdUserId == userInfo._id);
            const checkForceTask = true;
            // !forceCurrentTaskIds || forceCurrentTaskIds.includes(task._id);
            return checkProject && checkUser && checkForceTask;
        });
    };
    const [taskStack, setTaskStack] = useState<ITask[]>([]);
    const taskSelected = taskStack.length > 0 ? taskStack[taskStack.length - 1] : null;
    const setTaskSelected = (task: ITask | null) => {
        if (task) setTaskStack([task]);
        else setTaskStack([]);
    };
    const pushTask = (task: ITask) => {
        getTaskAPI(task._id).then((fullTask) => {
            if (fullTask) {
                setTaskStack((prev) => [...prev, fullTask]);
                history.replace(`?taskID=${fullTask._id}`);
            }
        }).catch(() => {
            setTaskStack((prev) => [...prev, task]);
            history.replace(`?taskID=${task._id}`);
        });
    };
    const popTask = () => setTaskStack((prev) => {
        const next = prev.length > 1 ? prev.slice(0, -1) : [];
        if (next.length > 0) {
            history.replace(`?taskID=${next[next.length - 1]._id}`);
        }
        return next;
    });
    const [openTestCase, setOpenTestCase] = useState<boolean>(false);
    const history = useHistory();
    const onSelectedTask = (task: ITask) => {
        let currentPathname = window.location.pathname;
        if (currentPathname === "/") {
            let pathname = "/task/" + task._id;
            history.push({ pathname: pathname });
        } else {
            history.push(`?taskID=${task._id}`);
        }
        if (!!forceCurrentCampaignIds?.length)
            history.push(`?${Constants.SHOW_CAMPAIGN_TASKS}=${forceCurrentCampaignIds.join(",")}`);
        setTaskShown(task);
    };
    const params: any = useParams();
    const taskID = params?.taskID ?? "";
    const searchParams = new URLSearchParams(window.location.search);
    const taskId = searchParams.get("taskID");
    useEffect(() => {
        let _taskId = taskId ?? taskID ?? "";
        if (_taskId) {
            // Skip fetch nếu task đã có trong stack (push/pop subtask)
            const alreadyInStack = taskStack.some((t) => t._id === _taskId);
            if (alreadyInStack) return;

            getTaskAPI(_taskId)
                .then((task) => {
                    if (task) {
                        setTaskShown(task);
                    }
                })
                .catch((e) => {
                    console.log("getTaskAPI err:", e);
                });
        }
    }, [taskID, taskId]);
    const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]);
    useEffect(() => {
        if (taskShown) {
            setTaskStack((prev) => {
                // Chỉ reset stack nếu task root thay đổi (click task khác trên Kanban)
                if (prev.length === 0 || prev[0]._id !== taskShown._id) {
                    return [taskShown];
                }
                return prev;
            });
        }
    }, [taskShown?._id]);
    const handleCheckboxChange = (taskId: string) =>{
    
        if(selectedTaskIds.includes(taskId)){
            setSelectedTaskIds(selectedTaskIds.filter((s) => s !== taskId))
        }
        else{
            setSelectedTaskIds([...selectedTaskIds,taskId])
        }
    };
    
    useEffect(() => {
        setSelectedTaskIds([])
    },[!isShowCheckBox])

    useEffect(() => {
        handleGetIds(isShowCheckBox ? selectedTaskIds : []);
    }, [selectedTaskIds, isShowCheckBox]);

    return (
        <div className="dashboard-sprint-columns-parent">
            <IconButton
                className="button-scroll left"
                onClick={() => ref.current?.scroll({ behavior: "smooth", left: 0 })}
                disableRipple
            >
                <ArrowBackIosIcon htmlColor="white" />
            </IconButton>
            <div className="status-bar"></div>
            <div className="dashboard-sprint-columns" ref={ref}>
                {status
                    .filter((s) => {
                        if (
                            [
                                Config.COLUMN_STATUS.TO_DO.mongoId,
                                Config.COLUMN_STATUS.IN_PROGRESS.mongoId,
                                Config.COLUMN_STATUS.QA_TESTING.mongoId,
                                Config.COLUMN_STATUS.DONE.mongoId,
                            ].includes(s._id) ||
                            isAdmin
                        )
                            return true;

                        const _tasks = mapTasks.get(s._id) ?? [];
                        let index = _tasks.findIndex((task) => {
                            let res = checkContainsArray(
                                [task.reporterId, task.assigneeId, task.leadDevId, ...task.testerIds, ...task.inform],
                                [...currentUserIds, userInfo._id]
                            );
                            return res;
                        });
                        return ["technical", "manager", "hr"].includes(userInfo.teams) || index > -1;
                    })
                    .map((status, index) => {
                        const _tasks = filterTasks(mapTasks.get(status._id) ?? [], status._id)
                            .map((task) => {
                                //prepare for sort task by change-time
                                let orderTime = -1;
                                if (!!task.createdTime) {
                                    // co createdTime
                                    let t = new Date(task.createdTime).getTime();
                                    if (task.histories.length) {
                                        let t1 = new Date(task.histories[0].time).getTime();
                                        orderTime = t1 > t ? t1 : t;
                                    } else orderTime = t;
                                } else {
                                    if (task.histories.length) {
                                        let t1 = new Date(task.histories[0].time).getTime();
                                        orderTime = t1;
                                    }
                                }
                                if (!task.priority) task.priority = "Lowest";
                                return { ...task, orderTime: orderTime };
                            })
                            .sort((a, b) => {
                                return b.orderTime - a.orderTime;
                            })
                            .sort((a, b) => {
                                let priorityPool = Object.values(Config.PRIORITY_POOL);
                                let orderA = priorityPool.findIndex((p) => p.toLowerCase() === a.priority.toLowerCase());
                                let orderB = priorityPool.findIndex((p) => p.toLowerCase() === b.priority.toLowerCase());
                                if (orderA < 0) orderA = 6;
                                if (orderB < 0) orderB = 6;
                                return orderA - orderB;
                            });
                        return (
                            <Column key={index} columnId={status._id}>
                                <div className="box-status">
                                    <StatusV2
                                        status={status}
                                        number={_tasks.filter((t) => t.type !== "Sub Task" || showAllTasks).length}
                                    />
                                </div>
                                {_tasks.map(
                                    (task) =>
                                        (task.type !== "Sub Task" || showAllTasks) && (
                                            <Fragment key={task._id}>
                                                <TaskPreview
                                                    task={task}
                                                    onSelectedTask={(t) => onSelectedTask(t)}
                                                    showAllTasks={showAllTasks}
                                                    handleCheckboxChange={handleCheckboxChange}
                                                    selectedTaskIds={selectedTaskIds}
                                                    isShowCheckBox={isShowCheckBox}
                                                />
                                            </Fragment>
                                        )
                                )}
                            </Column>
                        );
                    })
                    .filter((c) => !!c)}
            </div>
            <IconButton
                className="button-scroll right"
                disableRipple
                onClick={() =>
                    ref.current?.scroll({
                        behavior: "smooth",
                        left: ref.current?.clientWidth ?? 1000,
                    })
                }
            >
                <ArrowForwardIosIcon htmlColor="white" />
            </IconButton>
            {!openTestCase && taskStack.map((stackTask, idx) => {
                const isTop = idx === taskStack.length - 1;
                return (
                    <div
                        key={stackTask._id + "-" + idx}
                        style={{
                            position: "fixed",
                            inset: 0,
                            zIndex: 1050 + idx,
                            pointerEvents: isTop ? "auto" : "none",
                        }}
                    >
                        {/* Overlay mờ cho dialog không phải top */}
                        {!isTop && (
                            <div style={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0,0,0,0.15)",
                                zIndex: 0,
                                pointerEvents: "none",
                            }} />
                        )}
                        <div style={{
                            opacity: isTop ? 1 : 0.4,
                            transition: "opacity 0.2s",
                            pointerEvents: isTop ? "auto" : "none",
                            filter: isTop ? "none" : "grayscale(0.3)",
                        }}>
                            <NewEditTaskModal
                                onOpenTestCase={() => {
                                    setOpenTestCase(true);
                                }}
                                onHide={() => {
                                    if (taskStack.length > 1) {
                                        popTask();
                                        return;
                                    }
                                    setTaskSelected(null);
                                    setTaskShown(null);
                                    let id = taskID ?? taskId ?? "";
                                    if (taskID) {
                                        const task = allTasks.find((task) => task._id == id);
                                        let pathname = "/";
                                        if (task?.sprint?.shortId && !task?.sprint.activeSprint) {
                                            pathname = "/sprint/" + task?.sprint?.shortId;
                                        }
                                        history.push({ pathname: pathname });
                                    } else if (taskId) {
                                        history.push(window.location.pathname);
                                    }
                                    if (forceCurrentCampaignIds?.length)
                                        history.push(`?${Constants.SHOW_CAMPAIGN_TASKS}=${forceCurrentCampaignIds.join(",")}`);
                                }}
                                onSelectSubTask={pushTask}
                                task={allTasks.find((t) => t._id == stackTask._id) ?? stackTask}
                            />
                        </div>
                    </div>
                );
            })}
            {taskSelected && openTestCase && (
                <TestCycleModalWidget
                    task={taskSelected}
                    open={openTestCase}
                    handleClose={() => {
                        setOpenTestCase(false);
                        // setTaskSelected(null);
                    }}
                />
            )}
        </div>
    );
};

export default memo(DashboardSprintColumnsV2, (prev, next) => {
    if (
        prev.currentProjectIds.length != next.currentProjectIds.length ||
        prev.currentUserIds.length != next.currentUserIds.length ||
        prev.showAllTasks != next.showAllTasks ||
        prev.forceCurrentCampaignIds?.length != next.forceCurrentCampaignIds?.length ||
        JSON.stringify(prev.selectedFilters).localeCompare(JSON.stringify(next.selectedFilters)) != 0 ||
        prev.setMembersInGroup.length != next.setMembersInGroup.length ||
        prev.isShowCheckBox != next.isShowCheckBox
    ) {
        return false;
    }
    return true;
});

const StatusV2: FC<{ status: IStatus; number: number }> = ({ status, number }) => {
    const { title, color } = status;
    return (
        <>
            <div className="status-v2 white align-items-center justify-content-center">
                {title}
                <div
                    className="align-items-center justify-content-center number-of-tasks"
                    style={{
                        color: color,
                        background: hexToRgbA(color, 0.2),
                    }}
                >
                    {number}
                </div>
            </div>
        </>
    );
};
